import { useSyncExternalStore, type PointerEvent } from 'react';

// Phones in portrait, and touch screens too short for the floating call card
// (a phone in landscape is only about 390px tall). These get the full-width
// incoming call banner, the in-call bar and the full-screen call screen.
// Tablets and desktop windows keep the draggable card.
export const COMPACT_CALL_QUERY = '(max-width: 767px), (pointer: coarse) and (max-height: 500px)';

const subscribe = (onChange: () => void) => {
	const mql = window.matchMedia(COMPACT_CALL_QUERY);
	mql.addEventListener('change', onChange);
	return () => mql.removeEventListener('change', onChange);
};

const getSnapshot = () => window.matchMedia(COMPACT_CALL_QUERY).matches;

/** True when calls should use the phone call UI. Read synchronously, like useIsMobile. */
export function useCompactCallUi() {
	return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/**
 * onPointerDown for the roots of the phone call UI, which float above the
 * page. A dialog open on the page closes on any press outside it, which would
 * throw away what the person typed there, so presses that start in the call
 * UI's own DOM stop here. Presses in sheets it opens (portaled elsewhere,
 * like the More menu) carry on as normal.
 */
export function keepPageDialogsOpen(event: PointerEvent<HTMLElement>) {
	if (event.currentTarget.contains(event.target as Node)) event.stopPropagation();
}
